<script setup lang="ts">
import { ref } from 'vue'

import { useTypewriter } from '@/composables/useTypewriter'

// Номера строк гаттера — сниппет занимает 9 строк.
const GUTTER = Array.from({ length: 9 }, (_, i) => i + 1).join('\n')

const code = ref<HTMLElement | null>(null)
useTypewriter(code)
</script>

<template>
  <div class="code-window float-card glass" data-depth="26">
    <div class="cw-bar">
      <span class="cw-dot r"></span>
      <span class="cw-dot y"></span>
      <span class="cw-dot g"></span>
      <span class="cw-file"><span class="glyph">{ }</span>engineer.ts</span>
    </div>
    <pre class="cw-body"><span class="cw-gutter">{{ GUTTER }}</span><code ref="code" class="cw-code"></code></pre>
  </div>
</template>
